module.exports = __webpack_public_path__ + "img/btn.8d72973b.svg";